import { Close } from '@mui/icons-material';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import GenButton from './GenButton';

const PREFIX = 'GenConfirmDialog';

const classes = {
  title: `${PREFIX}-title`,
};

const DialogStyled = styled(Dialog)(({ theme }) => ({
  [`& .${classes.title}`]: {
    backgroundColor: '#FAFAFA',
    borderBottom: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

const GenConfirmDialog = ({
  open,
  onClose = () => {},
  onAgree = () => {},
  title,
  agreeText,
  agreeIcon = null,
  disagreeText,
  children,
  loading,
}) => {
  const { t } = useTranslation('global');
  return (
    <DialogStyled
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      maxWidth="xl"
    >
      <DialogTitle className={classes.title} id="alert-dialog-title">
        <Typography variant="subtitle1" sx={{ lineHeight: 1 }}>
          {title || t('confirmDialog.title')}
        </Typography>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ marginTop: '1rem' }}>{children}</DialogContent>
      <DialogActions sx={{ padding: '2rem' }}>
        <GenButton
          onClick={onClose}
          text={disagreeText || t('confirmDialog.disagreeText')}
        />
        <GenButton
          onClick={onAgree}
          text={agreeText || t('confirmDialog.agreeText')}
          endIcon={agreeIcon}
          variant="contained"
          loading={loading}
        />
      </DialogActions>
    </DialogStyled>
  );
};

export default GenConfirmDialog;
